import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';
import { fontNanumDaSiSiJagHae } from '@/styles/themes/variables';

export const Wrapper = styled.section`
  color: #e4e4e4;
  ${DESKTOP} {
    width: 542px;
  }
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px;
  ${DESKTOP} {
    font-size: 24px;
  }
`;

export const Letter = styled.div`
  position: relative;
  font-family: ${fontNanumDaSiSiJagHae};
  font-weight: 400;
  height: 231px;
  padding-top: 32px;
  font-size: 14px;
  ${DESKTOP} {
    width: 550px;
    height: 390px;
    padding-top: 60px;
    font-size: 24px;
    line-height: 26px;
  }
`;

export const LetterText = styled.div`
  position: relative;
  text-align: center;
  white-space: pre-wrap;
  color: #1b0b07;
  z-index: 10;
`;

export const ProjectVideo = styled.div`
  height: 184px;
  overflow: hidden;
  border-radius: 4px;
  ${DESKTOP} {
    height: 304px;
  }
`;

export const ProjectTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 8px 0;
`;

export const ProjectDesc = styled.p`
  margin: 0;
  font-weight: 300;
  text-align: justify;
`;
